import Paging from "../modules/Components/Paging";
import { useState, useEffect } from "react";
import env from "../env";
import tabletrans from "../translate/tables";
import errortrans from "../translate/error";
import ShemshPop from "../modules/Shemsh/ShemshPop";
import ShemshRow from "../modules/Shemsh/ShemshRow";
import ShemshFilters from "../modules/Shemsh/ShemshFilters";
import PostReq from "../utils/PostReq";
import Modal from "@mui/material/Modal";
import {
  getFiltersFromUrl,
  updateUrlWithFilters,
  defaultFilterValues,
  handleFilterChange,
} from "../utils/filterUtils"; // Import the utility functions

function Shemsh(props) {
  const direction = props.lang ? props.lang.dir : errortrans.defaultDir;
  const lang = props.lang ? props.lang.lang : errortrans.defaultLang;
  const [filters, setFilters] = useState(getFiltersFromUrl());
  const [loading, setLoading] = useState(0);
  const [content, setContent] = useState("");
  const [NewPop, setNewPop] = useState(false);
  const handleOpen = () => setNewPop(true);
  const handleClose = () => setNewPop(false);
  function handleFilterChange(newFilters) {
    setFilters(newFilters);
    updateUrlWithFilters(newFilters);
  }
  const FetchShemshList = async () => {
    setLoading(1);
    const result = await PostReq({
      method: "Post",
      url: "/xtra/list-shemsh",
      body: { ...filters },
    });
    setContent(result.filter);
    setLoading(0);
  };
  useEffect(() => {
    FetchShemshList();
  }, [filters]);
  return (
    <div className="user" style={{ direction: direction }}>
      <div className="od-header odHeaderBtnHolder">
        <div className="od-header-info">
          <div className="od-header-name">
            <p>{errortrans.shemsh[lang]}</p>
          </div>
        </div>
        <div className="od-header-btn">
          <label className="edit-btn" onClick={handleOpen}>
            <i className="fa-solid fa-plus"></i>
            ثبت شمش جدید
          </label>
        </div>
      </div>
      <div className="list-container">
        <ShemshFilters
          lang={props.lang}
          setFilters={handleFilterChange}
          updateUrlWithFilters={updateUrlWithFilters} // Pass the function as a prop
          filters={filters}
        />

        <div className="user-list">
          {loading ? (
            env.loader
          ) : (
            <>
              <table>
                <thead>
                  <tr>
                    <th>
                      <p>ردیف</p>
                    </th>

                    <th style={{ textAlign: "center" }}>
                      <p>از(گرم)</p>
                    </th>
                    <th>
                      <p>تا(گرم)</p>
                    </th>
                    <th>
                      <p>قیمت</p>
                    </th>
                    <th>
                      <p>عملیات</p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {content &&
                    content.map((data, i) => (
                      <ShemshRow
                        key={i}
                        data={data}
                        setData={setContent}
                        index={i + 1}
                      />
                    ))}
                </tbody>
              </table>
            </>
          )}
        </div>

        <Paging
          content={content}
          size={content.size}
          filters={filters}
          lang={props.lang}
          setFilters={handleFilterChange}
          updateUrlWithFilters={updateUrlWithFilters}
        />
      </div>
      <Modal
        open={NewPop}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ShemshPop handleClose={handleClose} setData={setContent} />
      </Modal>
    </div>
  );
}
export default Shemsh;
